export default {
  token: localStorage.getItem('auth-token') || null,
  status: 'start',

  confirm: '',
  parish: null
}
